import { cva as r } from "../../modules/index.es4.js";
const e = r("", {
  variants: {
    size: {
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), t = r(
  "inline-flex h-fit relative text-center cursor-pointer items-center space-x-1.5 justify-center ring-offset-background transition-all duration-200 ease-in-out focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 [&[disabled]]:pointer-events-none [&[disabled]]:opacity-50",
  {
    variants: {
      appearance: {
        gray: "bg-gray-200 border-gray-200 hover:bg-gray-200/50 hover:border-gray-200/50",
        deep: "bg-deep border-deep hover:bg-deep-1100 hover:border-deep-1100",
        primary: "bg-primary border-primary hover:bg-primary-1100 hover:border-primary-1100",
        secondary: "bg-secondary border-secondary hover:bg-secondary-1100 hover:border-secondary-1100",
        tertiary: "bg-tertiary border-tertiary hover:bg-tertiary-1100 hover:border-tertiary-1100",
        success: "bg-success border-success hover:bg-success-1100 hover:border-success-1100",
        danger: "bg-danger border-danger hover:bg-danger-1100 hover:border-danger-1100",
        warning: "bg-warning border-warning hover:bg-warning-1100 hover:border-warning-1100",
        info: "bg-info border-info hover:bg-info-1100 hover:border-info-1100",
        foreground: "bg-foreground border-foreground hover:bg-foreground/80 hover:border-foreground/80",
        background: "bg-background border-background hover:bg-background/80 hover:border-background/80"
      },
      variant: {
        default: "border-2 border-solid font-bold rounded-lg hover:border-solid hover:border-2",
        outline: "border-2 border-solid font-bold rounded-lg text-foreground bg-background hover:border-solid hover:border-2",
        bare: "font-semibold bg-tranparent hover:bg-transparent hover:border-inherit",
        link: "border-b border-dotted bg-tranparent hover:bg-transparent",
        ghost: "font-semibold rounded-lg hover:bg-transparent focus-visible:ring-offset-0",
        filter: "border-2 border-solid font-medium rounded-lg text-foreground bg-background hover:border-solid hover:border-2"
      },
      icon: {
        true: "!rounded-full"
      },
      size: {
        xs: "px-2 py-1 min-h-[28px] min-w-[28px] text-xs",
        sm: "px-4 py-1.5 min-h-[36px] min-w-[36px] text-sm",
        md: "px-6 py-2 min-h-[48px] min-w-[48px] text-base",
        lg: "px-8 py-2.5 min-h-[56px] min-w-[56px] text-lg"
      }
    },
    compoundVariants: [
      // Default
      {
        variant: "default",
        appearance: "gray",
        class: "text-gray"
      },
      {
        variant: "default",
        appearance: "deep",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "primary",
        class: "text-primary-foreground"
      },
      {
        variant: "default",
        appearance: "secondary",
        class: "text-secondary-foreground"
      },
      {
        variant: "default",
        appearance: "tertiary",
        class: "text-tertiary-foreground"
      },
      {
        variant: "default",
        appearance: "success",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "danger",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "warning",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "info",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "foreground",
        class: "text-white"
      },
      {
        variant: "default",
        appearance: "background",
        class: "text-gray"
      },
      // Outline
      {
        variant: "outline",
        appearance: "gray",
        class: "bg-gray-50 hover:bg-gray-50 dark:hover:bg-gray-50/10"
      },
      {
        variant: "outline",
        appearance: "deep",
        class: "hover:bg-deep-50 dark:hover:bg-deep-50/10"
      },
      {
        variant: "outline",
        appearance: "primary",
        class: "hover:bg-primary-50 dark:hover:bg-primary-50/10"
      },
      {
        variant: "outline",
        appearance: "secondary",
        class: "hover:bg-secondary-50 dark:hover:bg-secondary-50/10"
      },
      {
        variant: "outline",
        appearance: "tertiary",
        class: "hover:bg-tertiary-50 dark:hover:bg-tertiary-50/10"
      },
      {
        variant: "outline",
        appearance: "success",
        class: "hover:bg-success-50 dark:hover:bg-success-50/10"
      },
      {
        variant: "outline",
        appearance: "danger",
        class: "hover:bg-danger-50 dark:hover:bg-danger-50/10"
      },
      {
        variant: "outline",
        appearance: "warning",
        class: "hover:bg-warning-50 dark:hover:bg-warning-50/10"
      },
      {
        variant: "outline",
        appearance: "info",
        class: "hover:bg-info-50 dark:hover:bg-info-50/10"
      },
      {
        variant: "outline",
        appearance: "foreground",
        class: "bg-transparent text-foreground hover:bg-foreground/5"
      },
      {
        variant: "outline",
        appearance: "background",
        class: "bg-transparent text-background hover:bg-foreground/5"
      },
      // Filter
      {
        variant: "filter",
        class: "border-gray-200 hover:bg-gray-50 data-[populated='true']:border-primary data-[populated='true']:border-[2px]"
      },
      {
        variant: "filter",
        appearance: "primary",
        class: "data-[aria-checked='true']:border-primary"
      },
      {
        variant: "filter",
        appearance: "secondary",
        class: "data-[aria-checked='true']:border-secondary"
      },
      {
        variant: "filter",
        appearance: "tertiary",
        class: "data-[aria-checked='true']:border-tertiary"
      },
      {
        variant: "filter",
        appearance: "success",
        class: "data-[aria-checked='true']:border-success"
      },
      {
        variant: "filter",
        appearance: "danger",
        class: "data-[aria-checked='true']:border-danger"
      },
      {
        variant: "filter",
        appearance: "warning",
        class: "data-[aria-checked='true']:border-warning"
      },
      {
        variant: "filter",
        appearance: "info",
        class: "data-[aria-checked='true']:border-info"
      },
      {
        variant: "filter",
        appearance: "foreground",
        class: "data-[aria-checked='true']:border-foreground"
      },
      {
        variant: "filter",
        appearance: "background",
        class: "data-[aria-checked='true']:border-background"
      },
      // Link / Bare
      {
        variant: ["link", "bare"],
        appearance: "gray",
        class: "p-0 min-h-0 w-auto text-gray hover:text-gray-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "deep",
        class: "p-0 min-h-0 w-auto text-deep hover:text-deep-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "primary",
        class: "p-0 min-h-0 w-auto text-primary hover:text-primary-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "secondary",
        class: "p-0 min-h-0 w-auto text-secondary hover:text-secondary-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "tertiary",
        class: "p-0 min-h-0 w-auto text-tertiary hover:text-tertiary-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "success",
        class: "p-0 min-h-0 w-auto text-success hover:text-success-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "danger",
        class: "p-0 min-h-0 w-auto text-danger hover:text-danger-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "warning",
        class: "p-0 min-h-0 w-auto text-warning hover:text-warning-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "info",
        class: "p-0 min-h-0 w-auto text-info hover:text-info-1100"
      },
      {
        variant: ["link", "bare"],
        appearance: "foreground",
        class: "p-0 min-h-0 w-auto text-foreground hover:text-foreground/90"
      },
      {
        variant: ["link", "bare"],
        appearance: "background",
        class: "p-0 min-h-0 w-auto text-background hover:text-background/90"
      },
      // Ghost
      {
        variant: "ghost",
        appearance: "gray",
        class: "bg-transparent border-transparent text-gray hover:text-gray-1100"
      },
      {
        variant: "ghost",
        appearance: "deep",
        class: "bg-transparent border-transparent text-deep hover:text-deep-1100"
      },
      {
        variant: "ghost",
        appearance: "primary",
        class: "bg-transparent border-transparent text-primary hover:text-primary-1100"
      },
      {
        variant: "ghost",
        appearance: "secondary",
        class: "bg-transparent border-transparent text-secondary hover:text-secondary-1100"
      },
      {
        variant: "ghost",
        appearance: "tertiary",
        class: "bg-transparent border-transparent text-tertiary hover:text-tertiary-1100"
      },
      {
        variant: "ghost",
        appearance: "success",
        class: "bg-transparent border-transparent text-success hover:text-success-1100"
      },
      {
        variant: "ghost",
        appearance: "danger",
        class: "bg-transparent border-transparent text-danger hover:text-danger-1100"
      },
      {
        variant: "ghost",
        appearance: "warning",
        class: "bg-transparent border-transparent text-warning hover:text-warning-1100"
      },
      {
        variant: "ghost",
        appearance: "info",
        class: "bg-transparent border-transparent text-info hover:text-info-1100"
      },
      {
        variant: "ghost",
        appearance: "foreground",
        class: "bg-transparent border-transparent text-foreground hover:text-foreground/90"
      },
      {
        variant: "ghost",
        appearance: "background",
        class: "bg-transparent border-transparent text-background hover:text-background/90"
      },
      // Is Icon
      {
        icon: !0,
        size: "xs",
        class: "px-1 size-[28px]"
      },
      {
        icon: !0,
        size: "sm",
        class: "px-1.5 size-[36px]"
      },
      {
        icon: !0,
        size: "md",
        class: "px-2 size-[48px]"
      },
      {
        icon: !0,
        size: "lg",
        class: "px-2.5 size-[56px]"
      }
    ],
    defaultVariants: {
      icon: !1,
      variant: "default",
      appearance: "primary",
      size: "md"
    }
  }
);
export {
  e as buttonIconVariants,
  t as buttonVariants
};
//# sourceMappingURL=Button.styles.es.js.map
